import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LegalTabs from './LegalTabs';
import {
  resolveLegalDocumentLocale,
  PRIVACY_SECTIONS_EN,
  type LegalDocumentLocale,
  type LegalTableSection,
} from './legalContent';
import { PRIVACY_SECTIONS_AR, PRIVACY_SECTIONS_ID, PRIVACY_SECTIONS_MN } from './privacyTranslations';

const PRIVACY_SECTIONS: LegalTableSection[] = [
  {
    title: '제1조 (개인정보의 처리 목적)',
    paragraphs: [
      '주식회사 뉴베이스(이하 "회사")는 메디크루 웹사이트, 모바일 애플리케이션, VR 기반 의료 시뮬레이션, 교육 콘텐츠, 클래스·커리큘럼 관리, 실습 결과 관리, 주문·결제 및 관련 부가서비스(이하 "서비스") 제공을 위해 개인정보를 처리합니다.',
    ],
    items: [
      '회원 가입, 본인 확인, 계정 관리 및 서비스 이용 자격 확인',
      '기관, 클래스, 커리큘럼, 라이선스, 장비, 주문 및 결제 관리',
      'VR·모바일 시뮬레이션 학습, 실습 기록, 평가 결과 및 학습 이력 제공',
      '고객 문의, 공지, 장애 대응, 분쟁 처리 및 서비스 운영 안내',
      '서비스 품질 개선, 통계 분석, 보안 및 부정 이용 방지',
    ],
  },
  {
    title: '제2조 (개인정보의 처리 근거 및 동의 구분)',
    paragraphs: [
      '회사는 개인정보 보호법 등 관계 법령에 따라 서비스 이용계약의 체결 및 이행, 법령상 의무 준수, 정보주체의 동의 등 적법한 근거에 따라 개인정보를 처리합니다.',
    ],
    items: [
      '회원 가입, 로그인, 클래스 참여, 주문·결제, 고객문의 처리 등 서비스 제공에 필수적인 개인정보는 서비스 이용계약 이행을 위해 처리합니다.',
      '마케팅 정보 수신, 선택 기능 제공, 민감정보 또는 고유식별정보 처리 등 별도 동의가 필요한 경우에는 수집·이용 목적, 항목, 보유 기간, 동의 거부에 따른 불이익을 별도로 안내하고 동의를 받습니다.',
      '정보주체는 선택 동의를 거부할 수 있으며, 선택 동의를 거부하더라도 기본 서비스 이용은 제한되지 않습니다. 다만 해당 선택 기능 또는 혜택 제공은 제한될 수 있습니다.',
    ],
  },
  {
    title: '제3조 (처리하는 개인정보 항목)',
    paragraphs: ['회사는 서비스 제공에 필요한 최소한의 개인정보를 처리합니다.'],
    items: [
      '회원 정보: 이름, 이메일, 로그인 ID, 비밀번호, 휴대전화번호, 소속 기관, 직무 또는 권한, 계정 상태',
      '기관 및 관리자 정보: 기관명, 직무, 담당자명, 연락처, 계약 및 주문 관련 정보',
      '학습 및 실습 정보: 클래스 참여 이력, 콘텐츠 이용 기록, 실습 결과, 평가 결과, 학습 진도, 제출 자료',
      '결제 및 주문 정보: 주문 상품, 결제 금액, 결제수단, 세금계산서 또는 영수증 발행에 필요한 정보',
      '서비스 이용 정보: 접속 로그, 쿠키, 기기 정보, IP 주소, 브라우저 정보, 오류 로그, 보안 로그',
      '고객문의 정보: 이름, 이메일, 연락처, 문의 내용, 첨부파일 및 상담 처리 이력',
      '인공지능 기능 이용 정보: AI 기능에 입력한 텍스트, 첨부파일, 서비스 이용 맥락, 생성된 응답, 오류 로그 및 응답 생성에 필요한 정보',
      '서비스 이용 과정에서 자동 생성되는 정보: 접속 일시, 이용 기록, 클래스·콘텐츠 이용 이력, 결제 처리 결과, 부정 이용 탐지 기록',
    ],
  },
  {
    title: '제4조 (개인정보의 처리 및 보유 기간)',
    paragraphs: [
      '회사는 개인정보 수집·이용 목적이 달성되거나 회원 탈퇴, 이용계약 종료 등 보유 필요성이 없어진 경우 지체 없이 개인정보를 파기합니다. 다만 관계 법령에 따라 보존할 필요가 있는 경우에는 해당 기간 동안 분리하여 보관합니다.',
    ],
    items: [
      '회원 정보: 회원 탈퇴 또는 이용계약 종료 시까지. 단, 부정 이용 방지 및 분쟁 대응을 위해 필요한 최소 정보는 탈퇴 후 1년까지 보관할 수 있습니다.',
      '기관 계약 및 관리자 정보: 계약 종료 후 5년까지. 단, 계약 이행, 정산, 분쟁 대응에 필요한 범위로 제한합니다.',
      '학습 이력 및 실습 결과: 서비스 제공 기간 또는 기관회원과의 계약에서 정한 기간까지. 계약 종료 후에는 교육 이력 확인, 분쟁 대응, 법령상 의무 이행에 필요한 범위에서 보관합니다.',
      '계약 또는 청약철회 등에 관한 기록: 전자상거래 등에서의 소비자보호에 관한 법률에 따라 5년',
      '대금결제 및 재화 등의 공급에 관한 기록: 전자상거래 등에서의 소비자보호에 관한 법률에 따라 5년',
      '소비자 불만 또는 분쟁처리에 관한 기록: 전자상거래 등에서의 소비자보호에 관한 법률에 따라 3년',
      '표시·광고에 관한 기록: 전자상거래 등에서의 소비자보호에 관한 법률에 따라 6개월',
      '접속 로그 등 통신사실확인자료: 통신비밀보호법 등 관계 법령에 따라 3개월',
    ],
  },
  {
    title: '제5조 (개인정보의 제3자 제공)',
    paragraphs: [
      '회사는 정보주체의 동의가 있거나 법령에 특별한 근거가 있는 경우를 제외하고 개인정보를 제3자에게 제공하지 않습니다.',
    ],
    items: [
      '제공받는 자: 회원이 소속되었거나 참여한 클래스·교육 과정을 관리하는 기관회원 및 기관 관리자',
      '제공 목적: 클래스 운영, 학습자 관리, 실습 결과 확인, 교육 이력 관리, 기관 계약 이행',
      '제공 항목: 이름, 이메일, 소속, 권한, 클래스 참여 이력, 학습 진도, 실습 기록, 평가 결과',
      '보유 및 이용 기간: 기관회원의 계약 기간 또는 교육 운영 목적 달성 시까지. 단, 관계 법령 또는 계약상 보관 의무가 있는 경우 해당 기간까지 보관할 수 있습니다.',
      '그 밖에 개인정보를 제3자에게 제공할 필요가 있는 경우 회사는 제공받는 자, 제공 목적, 제공 항목, 보유 및 이용 기간을 사전에 안내하고 별도 동의를 받습니다.',
    ],
  },
  {
    title: '제6조 (개인정보 처리의 위탁)',
    paragraphs: [
      '회사는 안정적인 서비스 제공을 위해 개인정보 처리업무의 일부를 외부 전문 업체에 위탁할 수 있습니다. 위탁 시 관련 법령에 따라 개인정보 보호에 필요한 사항을 계약에 반영하고 수탁자를 관리·감독합니다.',
    ],
    items: [
      '토스페이먼츠 주식회사: 카드 결제, 결제 승인·취소, 결제 결과 확인 및 정산 처리',
      'Amazon Web Services, Inc. 및 계열사: 서비스 서버, 데이터베이스, 파일 저장소, 백업, 보안 및 인프라 운영',
      'Google LLC 및 계열사: Gemini API를 통한 생성형 인공지능 기능 제공, 사용자 입력 처리, 응답 생성, 오류 분석 및 서비스 품질 개선',
      'OpenAI, L.L.C. 및 계열사: GPT API를 통한 생성형 인공지능 기능 제공, 사용자 입력 처리, 응답 생성, 오류 분석 및 서비스 품질 개선',
      '이메일·알림 발송 사업자: 본인확인, 계정 알림, 서비스 공지, 문의 답변 발송',
      '고객지원 및 업무 협업 도구 제공 사업자: 고객 문의 접수, 상담 이력 관리, 장애 대응',
      '위탁업무 또는 수탁자가 변경되는 경우 회사는 개인정보처리방침을 통해 지체 없이 공개합니다. 수탁자가 대규모이거나 빈번하게 변경되는 경우에는 수탁자 유형과 실제 수탁자 확인 경로를 함께 안내합니다.',
    ],
  },
  {
    title: '제7조 (개인정보의 국외 이전)',
    paragraphs: [
      '회사는 서비스 제공, 클라우드 인프라 운영, 생성형 인공지능 기능 제공을 위해 개인정보를 국외로 이전할 수 있습니다. 국외 이전은 서비스 이용계약의 체결 및 이행을 위한 처리위탁·보관, 정보주체의 별도 동의 또는 관계 법령상 허용되는 근거에 따라 이루어집니다.',
      '회사는 서비스 안정성, 백업, 장애 대응, 지연시간 개선을 위해 복수의 클라우드 리전 또는 API 서비스 운영 국가를 사용할 수 있습니다. 현재 이용 중인 국외 이전 현황은 아래 표에서 확인할 수 있으며, 리전 또는 이전 국가가 변경되는 경우 본 방침 또는 공지사항을 통해 안내합니다.',
    ],
    table: {
      headers: ['이전받는 자', '이전 국가', '이전 항목', '이전 일시 및 방법', '이용 목적', '보유 및 이용 기간'],
      rows: [
        [
          'Amazon Web Services, Inc. 및 계열사',
          '회사가 이용하는 AWS 리전 소재 국가. 서비스 운영 상황에 따라 대한민국, 일본, 싱가포르, 미국, 유럽연합 등 복수 리전이 사용될 수 있습니다.',
          '회원 정보, 기관·관리자 정보, 학습 및 실습 정보, 결제·주문 정보, 서비스 이용 로그, 고객문의 정보',
          '서비스 이용 및 데이터 저장·백업이 필요한 시점에 암호화된 네트워크를 통해 전송',
          '서비스 서버 운영, 데이터 보관, 백업, 보안, 장애 대응',
          '서비스 제공 기간 또는 클라우드 이용계약 종료 시까지',
        ],
        [
          'Google LLC 및 계열사',
          '미국 등 Google이 Gemini API 서비스를 운영하는 국가',
          'Gemini API 이용 시 입력한 텍스트, 첨부파일, 서비스 이용 맥락, 오류 로그 및 응답 생성에 필요한 정보',
          '인공지능 기능 이용 시 API 연동을 통해 네트워크 전송',
          'AI 응답 생성, 기능 제공, 오류 분석, 보안 및 서비스 품질 개선',
          'Google의 유료 Gemini API 또는 이에 준하는 설정 기준으로 모델 학습에는 사용하지 않으며, 보안·남용 방지 목적 등으로 API 이용계약·서비스 약관·계정 설정에서 정한 기간까지. 현재 정책상 유료 Gemini API는 남용 방지 목적으로 최대 55일 보관될 수 있습니다.',
        ],
        [
          'OpenAI, L.L.C. 및 계열사',
          '미국 등 OpenAI가 GPT API 서비스를 운영하는 국가',
          'GPT API 이용 시 입력한 텍스트, 첨부파일, 서비스 이용 맥락, 오류 로그 및 응답 생성에 필요한 정보',
          '인공지능 기능 이용 시 API 연동을 통해 네트워크 전송',
          'AI 응답 생성, 기능 제공, 오류 분석, 보안 및 서비스 품질 개선',
          '기본적으로 모델 학습에는 사용하지 않으며, 보안·남용 모니터링 목적 등으로 API 이용계약·서비스 약관·계정 설정에서 정한 기간까지. 현재 정책상 OpenAI API는 남용 모니터링 목적으로 최대 30일 보관될 수 있습니다.',
        ],
      ],
    },
    items: [
      '국외 이전을 원하지 않는 경우 정보주체는 고객센터를 통해 거부 의사를 표시하거나 해당 기능 이용을 중단할 수 있습니다. 다만 클라우드 인프라, 계정 관리, 결제, 인공지능 기능 등 서비스 제공에 필수적인 국외 이전을 거부하는 경우 서비스 전부 또는 일부 이용이 제한될 수 있습니다.',
      '국외 이전 대상, 국가, 항목, 목적, 보유 기간 또는 이전 거부 방법이 변경되는 경우 회사는 개인정보처리방침, 공지사항, 전자우편 등 합리적인 방법으로 안내합니다.',
    ],
  },
  {
    title: '제8조 (정보주체와 법정대리인의 권리)',
    items: [
      '정보주체는 회사에 개인정보 열람, 정정, 삭제, 처리정지, 동의 철회 및 회원 탈퇴를 요청할 수 있습니다.',
      '회원은 서비스 내 계정 설정 또는 고객센터를 통해 개인정보를 확인하거나 수정할 수 있습니다.',
      '권리 행사는 서면, 전자우편, 고객센터 등으로 할 수 있으며, 회사는 요청자가 본인 또는 정당한 대리인인지 확인한 후 관련 법령에 따라 지체 없이 조치합니다.',
      '법정대리인 또는 위임을 받은 대리인이 권리를 행사하는 경우 회사는 위임장 등 정당한 대리권을 확인할 수 있는 자료를 요청할 수 있습니다.',
      '법령상 보관 의무가 있거나 다른 법령에서 수집 대상으로 명시한 정보, 서비스 계약 이행 및 정산에 필요한 정보는 삭제 또는 처리정지가 제한될 수 있습니다.',
    ],
  },
  {
    title: '제9조 (개인정보의 파기)',
    items: [
      '회사는 개인정보 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 해당 개인정보를 파기합니다.',
      '파기 절차: 파기 사유가 발생한 개인정보를 선정하고, 내부 승인 절차를 거쳐 개인정보 보호책임자 또는 담당부서의 확인 후 파기합니다.',
      '전자적 파일은 복구 또는 재생되지 않도록 안전한 방법으로 삭제하며, 종이 문서는 분쇄 또는 소각합니다.',
      '법령에 따라 보관해야 하는 정보는 다른 개인정보와 분리하여 보관합니다.',
    ],
  },
  {
    title: '제10조 (쿠키 및 자동 수집 장치의 이용)',
    paragraphs: [
      '회사는 로그인 유지, 사용자 환경 설정, 서비스 이용 분석을 위해 쿠키를 사용할 수 있습니다. 이용자는 브라우저 설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있으나, 이 경우 일부 서비스 이용이 제한될 수 있습니다.',
    ],
    items: [
      'Chrome: 설정 > 개인정보 보호 및 보안 > 서드 파티 쿠키 또는 사이트 데이터 설정',
      'Safari: 설정 > 개인정보 보호 > 쿠키 및 웹사이트 데이터 설정',
      'Edge: 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리',
      '회사가 제3자 행태정보 수집 도구 또는 맞춤형 광고 도구를 도입하는 경우 수집 항목, 수집 방법, 이용 목적, 보유 기간 및 거부 방법을 별도로 안내합니다.',
    ],
  },
  {
    title: '제11조 (민감정보 및 고유식별정보)',
    paragraphs: [
      '회사는 법령상 허용되거나 정보주체의 별도 동의를 받은 경우를 제외하고 민감정보 또는 고유식별정보를 처리하지 않습니다. 서비스는 의료교육을 위한 시뮬레이션 서비스이므로, 회원은 실제 환자의 진료정보, 건강정보, 주민등록번호 등 민감정보 또는 고유식별정보를 서비스에 입력하거나 업로드하지 않아야 합니다.',
    ],
  },
  {
    title: '제12조 (가명정보 처리)',
    paragraphs: [
      '회사는 통계 작성, 과학적 연구, 공익적 기록보존 등을 위해 필요한 경우 관련 법령에 따라 개인정보를 가명처리하여 활용할 수 있습니다. 가명정보를 처리하는 경우 처리 목적, 처리 항목, 보유 기간, 안전성 확보조치 및 제3자 제공 여부를 별도로 관리합니다.',
    ],
  },
  {
    title: '제13조 (자동화된 결정 및 인공지능 기능)',
    paragraphs: [
      '회사는 정보주체에게 법적 효과를 발생시키거나 중대한 영향을 미치는 결정을 완전히 자동화된 방식만으로 수행하지 않습니다.',
      '회사는 Gemini API, GPT API 등 생성형 인공지능 API 또는 자동화된 평가 기능을 서비스 기능의 일부로 사용할 수 있습니다. 이 경우 인공지능 기능은 교육 콘텐츠 작성·보조, 문의 응답 보조, 실습 결과 분석 보조, 운영 효율화 등 회사가 안내한 목적 범위에서 사용됩니다.',
      '인공지능 기능 이용 시 정보주체가 입력한 텍스트, 첨부파일, 서비스 이용 맥락, 실습 결과, 오류 로그 및 응답 생성에 필요한 정보가 Google LLC, OpenAI, L.L.C. 등 국외 API 제공 사업자에게 전송될 수 있습니다.',
      '회사는 인공지능 기능을 운영할 때 실제 환자의 진료정보, 건강정보, 주민등록번호, 여권번호, 운전면허번호 등 민감정보 또는 고유식별정보를 입력하지 않도록 안내합니다. 정보주체는 인공지능 기능 이용 시 제3자의 개인정보나 실제 환자정보를 입력해서는 안 됩니다.',
      '회사는 이용자 입력값과 응답값이 API 제공 사업자의 범용 모델 학습 또는 제품 개선에 사용되지 않는 설정, 요금제 또는 API 이용 방식을 우선 적용합니다. 현재 OpenAI API는 기본적으로 모델 학습에 사용하지 않으며 남용 모니터링 목적으로 최대 30일 보관될 수 있고, Google의 유료 Gemini API는 모델 학습에 사용하지 않으며 남용 방지 목적으로 최대 55일 보관될 수 있습니다.',
      '회사는 가능한 경우 저장 비활성화, Zero Data Retention 또는 이에 준하는 저장 최소화 설정을 검토·적용합니다. 모델 학습에 활용되는 API, 무료 API, 파인튜닝, 파일 저장, 벡터 저장소, 캐싱 등 별도 보관이 발생할 수 있는 기능을 사용하는 경우 회사는 학습 활용 여부, 보관 기간, 거부 방법 및 거부 효과를 별도로 안내합니다.',
      '정보주체는 인공지능 기능 이용 중단, 입력 정보 삭제 요청, 부적절한 답변에 대한 신고 또는 이의제기를 고객센터를 통해 요청할 수 있습니다. 다만 인공지능 기능 이용을 거부하는 경우 해당 기능 또는 관련 서비스 이용이 제한될 수 있습니다.',
      '단말기 내부에서만 처리되는 온디바이스 기능을 제공하는 경우 회사는 외부 서버 전송 여부와 단말기 내 데이터 삭제 기준을 안내합니다.',
    ],
  },
  {
    title: '제14조 (개인정보의 안전성 확보 조치)',
    items: [
      '개인정보의 안전한 처리를 위한 내부 관리계획 수립 및 시행',
      '개인정보 접근 권한의 제한 및 접근 기록 관리',
      '개인정보처리시스템에 대한 접근 통제 및 침입 탐지·차단 조치',
      '비밀번호 등 인증 정보의 암호화 저장',
      '전송 구간 암호화 등 네트워크 보안 조치',
      '접속 기록의 보관, 점검 및 위조·변조 방지 조치',
      '악성 프로그램 방지, 보안 취약점 점검, 로그 모니터링 및 침해 사고 대응 절차 운영',
      '개인정보 취급자에 대한 교육 및 내부 관리 절차 운영',
    ],
  },
  {
    title: '제15조 (아동의 개인정보)',
    paragraphs: [
      '회사는 원칙적으로 만 14세 미만 아동의 개인정보를 수집하지 않습니다. 서비스 이용 과정에서 만 14세 미만 아동의 개인정보 처리가 필요한 경우 관련 법령에 따라 법정대리인의 동의를 받습니다.',
    ],
  },
  {
    title: '제16조 (개인정보 보호책임자 및 고충처리 부서)',
    paragraphs: [
      '회사는 개인정보 처리와 관련한 문의, 불만 처리, 피해 구제 등을 위해 아래 연락처를 운영합니다.',
      '개인정보 보호책임자 또는 개인정보 보호 담당부서: 주식회사 뉴베이스 개인정보보호 담당부서',
      '이메일: contact@newbase.kr',
      '전화: 02-564-8853',
      '개인정보 열람청구, 정정·삭제, 처리정지, 동의 철회 및 고충처리는 위 연락처를 통해 접수할 수 있습니다.',
    ],
  },
  {
    title: '제17조 (권익침해 구제 방법)',
    items: [
      '개인정보침해신고센터: 국번없이 118, privacy.kisa.or.kr',
      '개인정보분쟁조정위원회: 1833-6972, www.kopico.go.kr',
      '대검찰청 사이버수사과: 국번없이 1301, www.spo.go.kr',
      '경찰청 사이버수사국: 국번없이 182, ecrm.police.go.kr',
    ],
  },
  {
    title: '제18조 (개인정보처리방침의 변경)',
    paragraphs: [
      '회사는 관련 법령, 서비스 정책 또는 개인정보 처리 현황 변경에 따라 이 개인정보처리방침을 개정할 수 있습니다. 정보주체의 권리에 중대한 영향을 미치는 변경은 시행 전 또는 변경 즉시 서비스 화면, 공지사항, 전자우편 등 합리적인 방법으로 안내합니다.',
      '동일한 위탁업무를 수행하는 수탁자 또는 재수탁자 목록 변경과 같이 권리 침해 가능성이 낮은 사항은 일정 기간의 변경 내용을 모아 안내할 수 있습니다.',
      '이 개인정보처리방침은 2026.05.06부터 적용됩니다.',
    ],
  },
];

export default function PrivacyPolicy(): React.ReactElement {
  const { i18n } = useTranslation();
  const legalLocale = resolveLegalDocumentLocale(i18n.language);
  const privacySectionsByLocale: Record<LegalDocumentLocale, LegalTableSection[]> = {
    ko: PRIVACY_SECTIONS,
    en: PRIVACY_SECTIONS_EN,
    ar: PRIVACY_SECTIONS_AR,
    id: PRIVACY_SECTIONS_ID,
    mn: PRIVACY_SECTIONS_MN,
  };
  const privacyHeaderByLocale: Record<LegalDocumentLocale, { title: string; effectiveDate: string }> = {
    ko: { title: '메디크루 개인정보처리방침', effectiveDate: '시행일: 2026.05.06' },
    en: { title: 'Medicrew Privacy Policy', effectiveDate: 'Effective date: May 6, 2026' },
    ar: { title: 'سياسة خصوصية Medicrew', effectiveDate: 'تاريخ النفاذ: 6 مايو 2026' },
    id: { title: 'Kebijakan Privasi Medicrew', effectiveDate: 'Tanggal berlaku: 6 Mei 2026' },
    mn: { title: 'Medicrew нууцлалын бодлого', effectiveDate: 'Хүчин төгөлдөр болох огноо: 2026.05.06' },
  };
  const privacySections = privacySectionsByLocale[legalLocale];
  const privacyHeader = privacyHeaderByLocale[legalLocale];

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <article className="mx-auto max-w-[920px]" dir={legalLocale === 'ar' ? 'rtl' : undefined}>
      <LegalTabs activeTab="privacy" />

      <header className="pt-8 border-b border-gray-200 pb-8">
        <p className="mt-3 text-4xl font-semibold text-gray-900">
          {privacyHeader.title}
        </p>
        <p className="mt-4 text-base text-gray-500">
          {privacyHeader.effectiveDate}
        </p>
      </header>

      <div className="mt-16 space-y-10 text-base leading-8 text-gray-700">
        {privacySections.map((section) => (
          <section key={section.title}>
            <h2 className="mb-4 text-xl font-bold text-gray-900">{section.title}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="mb-3">
                {paragraph}
              </p>
            ))}
            {section.items && (
              <ol className="list-decimal space-y-2 pl-5">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            )}
            {section.table && (
              <div className="mt-5 overflow-x-auto rounded-lg border border-gray-200">
                <table className="min-w-full border-collapse text-left text-sm leading-6">
                  <thead className="bg-gray-50 text-gray-900">
                    <tr>
                      {section.table.headers.map((header) => (
                        <th key={header} scope="col" className="border-b border-gray-200 px-4 py-3 font-semibold">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {section.table.rows.map((row) => (
                      <tr key={row.join('|')} className="align-top">
                        {row.map((cell, cellIndex) => (
                          <td key={`${row[0]}-${cellIndex}`} className="px-4 py-3 text-gray-700">
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        ))}
      </div>
    </article>
  );
}
